/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Compare_Col_Col_IndexInputs */

const en_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COL Index`)
};

const de_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenshaltungsindex`)
};

const fr_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indice du coût de la vie`)
};

const es_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice de costo de vida`)
};

const it_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indice COL`)
};

const nl_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COL-index`)
};

const pl_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indeks COL`)
};

const fi_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elinkust.indeksi`)
};

const da_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leveomk.indeks`)
};

const sv_salary_compare_col_col_index = /** @type {(inputs: Salary_Compare_Col_Col_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levnadskostn.index`)
};

/**
* | output |
* | --- |
* | "COL Index" |
*
* @param {Salary_Compare_Col_Col_IndexInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_compare_col_col_index = /** @type {((inputs?: Salary_Compare_Col_Col_IndexInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Compare_Col_Col_IndexInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_compare_col_col_index(inputs)
	if (locale === "fr") return fr_salary_compare_col_col_index(inputs)
	if (locale === "es") return es_salary_compare_col_col_index(inputs)
	if (locale === "it") return it_salary_compare_col_col_index(inputs)
	if (locale === "nl") return nl_salary_compare_col_col_index(inputs)
	if (locale === "pl") return pl_salary_compare_col_col_index(inputs)
	if (locale === "fi") return fi_salary_compare_col_col_index(inputs)
	if (locale === "da") return da_salary_compare_col_col_index(inputs)
	if (locale === "sv") return sv_salary_compare_col_col_index(inputs)
	return en_salary_compare_col_col_index(inputs)
});